import { Card, CardActions, CardContent, Grid, Skeleton } from '@mui/material'
import Header from 'components/Header'
import { BasePathProvider } from 'components/Providers'

export default function SubstitutePortalFormSkeleton() {

  return (
    <BasePathProvider>
      <Card data-component="SubstitutePortalFormSkeleton" elevation={0} >
        <Header title={<Skeleton variant="rounded" width={'100%'} height={30} />} small close borderBottom />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item sm={6} xs={6} md={6}>
              <Skeleton variant="rounded" width={'100%'} height={30} />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
              <Skeleton variant="rounded" width={'100%'} height={30} />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
              <Skeleton variant="rounded" width={'100%'} height={30} />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
              <Skeleton variant="rounded"width={'100%'} height={30} />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
              <Skeleton variant="rounded"width={'100%'} height={30} />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
              <Skeleton variant="rounded"width={'100%'} height={30} />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
              <Skeleton variant="rounded"width={'100%'} height={30} />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
              <Skeleton variant="rounded"width={'100%'} height={30} />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
              <Skeleton variant="rounded"width={'100%'} height={30} />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
              <Skeleton variant="rounded"width={'100%'} height={30} />
            </Grid>
            <Grid item sm={12} xs={12} md={12}>
              <Skeleton variant="rounded"width={'100%'} height={30} />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions sx={{ display: 'flex', justifyContent: 'flex-end', mr: 1 }}>
            <Skeleton variant="rounded" width={100} height={30} />
        </CardActions>
      </Card>
    </BasePathProvider>
  )
}